import { defineStyleConfig } from '@chakra-ui/react'

export const baseInputTheme = defineStyleConfig({
  baseStyle: {
    inputContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      minWidth: 0,
      fontSize: '12px',
      gap: '8px',
      minHeight: '32px',
      paddingX: '8px',
      paddingY: '8px',
      border: '1px solid',
      borderColor: 'presets.neutral.30',
      borderRadius: '6px',
      backgroundColor: 'presets.neutral.0',
      cursor: 'text',
      maxWidth: '100%',
      _dark: {
        backgroundColor: 'presets.neutral.100',
        borderColor: 'presets.neutral.90',
        color: 'presets.neutral.0',
        _disabled: {
          color: 'presets.neutral.60',
          backgroundColor: 'presets.dark.surfacePanel',
          opacity: 0.8,
          cursor: 'not-allowed',
        },
      },
      _disabled: {
        backgroundColor: 'presets.neutral.10',
        cursor: 'not-allowed',
      },
      _focusWithin: {
        borderColor: 'presets.turquoise.70',
        boxShadow: 'none',
      },
      _hover: {
        borderColor: 'presets.turquoise.50',
      },
      '&[data-invalid="true"]': {
        borderColor: 'presets.pink.70 !important',
        boxShadow: '0 0 0 1px presets.pink.70',
      },
      '&[data-invalid="true"]:focus-within': {
        borderColor: 'presets.pink.70 !important',
        boxShadow: '0 0 0 1px presets.pink.70',
      },
    },
    field: {
      flex: '1 1 0',
      minWidth: 0,
      display: 'block',
      fontSize: 'inherit',
      lineHeight: '1',
      height: '1em',
      fontWeight: '500',
      color: 'presets.turquoise.100',
      boxSizing: 'border-box',
      border: '0',
      padding: '0px',

      // outline: 'none', original. commented due to other code disabling. reenable when global disable modified.
      outline: 'none !important', // disable global tab styles:

      _dark: {
        backgroundColor: 'transparent',
        color: 'inherit',
        _placeholder: {
          color: 'presets.neutral.0',
        },
        _disabled: {
          color: 'presets.neutral.60',
          _placeholder: {
            color: 'presets.neutral.60',
          },
        },
      },
      _disabled: {
        backgroundColor: 'transparent',
        color: 'rgba(0, 0, 0, 0.3)',
        cursor: 'not-allowed',
        _placeholder: {
          color: 'rgba(0, 0, 0, 0.3)',
        },
      },
      _placeholder: {
        color: 'rgba(0, 0, 0, 0.5)',
      },
    },
  },
  variants: {
    primary: {
      field: {
        // border: '1px solid',
        // borderColor: 'presets.neutral.30',
        // _focus: {
        //   borderColor: 'presets.turquoise.70 !important',
        //   boxShadow: 'none',
        // },
        // _hover: {
        //   borderColor: 'presets.turquoise.50',
        // },
      },
    },
    ghost: {},
    search: {
      inputContainer: {
        padding: '6px',
        fontSize: '16px',
        fontWeight: '500',
        borderRadius: '63px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'presets.neutral.20',
        backgroundColor: 'white',
        color: 'presets.neutral.90',
        _hover: {
          borderColor: 'presets.turquoise.50',
        },
        _focusWithin: {
          borderColor: 'presets.turquoise.50',
          boxShadow: 'none',
        },
        _dark: {
          borderColor: 'presets.turquoise.70',
          backgroundColor: 'rgba(0, 0, 0, 0.23)',
          color: 'presets.turquoise.10',
        },
      },
      field: {
        fontSize: '16px',
        fontWeight: '500',
        color: 'presets.neutral.90',
        backgroundColor: 'white',
        _placeholder: {
          color: 'presets.neutral.60',
        },
        _focusVisible: {
          color: 'presets.neutral.90',
          backgroundColor: 'white',
        },
        _dark: {
          color: 'presets.turquoise.10',
          backgroundColor: 'rgba(0, 0, 0, 0.23)',
          _placeholder: {
            color: 'presets.turquoise.10',
          },
          _focusVisible: {
            color: 'presets.turquoise.10',
            backgroundColor: 'rgba(0, 0, 0, 0.23)',
          },
        },
      },
    },
  },
  defaultProps: {
    variant: 'primary',
  },
})
